var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33 12.558c.166.069.236.252.166.412a4.462 4.462 0 0 0-.308 1.67v2.243h-4.47v-1.487c0-.847.332-1.625.947-2.22a3.254 3.254 0 0 1 2.293-.916c.473 0 .946.115 1.372.298zM15.102 16.906H6.874v-2.243c0-1.053.425-2.06 1.205-2.815a4.168 4.168 0 0 1 2.909-1.167c1.088 0 2.128.412 2.908 1.167a3.903 3.903 0 0 1 1.206 2.815v2.243zM15.789 14.64c0-.572-.095-1.121-.308-1.67-.07-.16 0-.343.166-.412a3.178 3.178 0 0 1 1.395-.298c.875 0 1.679.32 2.293.916.615.595.946 1.373.946 2.22v1.487h-4.469V14.64h-.023zM10.988 9.789c-1.584 0-2.861-1.236-2.861-2.77 0-1.533 1.277-2.769 2.861-2.769 1.585 0 2.862 1.236 2.862 2.77 0 1.533-1.277 2.769-2.862 2.769zM17.018 11.757c-1.253 0-2.293-.984-2.293-2.22 0-1.213 1.016-2.22 2.293-2.22 1.254 0 2.294.984 2.294 2.22 0 1.213-1.017 2.22-2.294 2.22zM4.958 11.757c-1.253 0-2.293-.984-2.293-2.22 0-1.213 1.016-2.22 2.293-2.22 1.277 0 2.294.984 2.294 2.22-.024 1.213-1.04 2.22-2.294 2.22z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.e61a44bd.svg";
export { ForwardRef as ReactComponent };